import {
    SET_TIPS,
    SET_TIPS_DELETE
} from "./types/mutations.js";

const mutations = {
    [SET_TIPS]: (state, payload) => {
        state.tips = payload;
    },
    [SET_TIPS_DELETE]: (state, payload) => {
        state.tips = state.tips.filter(item => item.id !== payload);
    }
};

export default mutations;
